import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { ToastrService } from 'ngx-toastr';
import { ProcessService } from 'src/app/shared/services/core/process.service';

@Component({
  selector: 'app-processamento',
  imports: [TegelModule, CommonModule],
  templateUrl: './processamento.component.html',
  styleUrl: './processamento.component.scss'
})
export class ProcessamentoComponent implements OnInit {
  creditForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private processService: ProcessService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.creditForm = this.formBuilder.group({
      credit: ['', Validators.required]
    });
  }

  initProcess(){
    this.processService.initProcess(this.creditForm.value).subscribe((result) => {
      if (result && !result.hasErrors) {
        this.toastr.success('Processo iniciado.', 'Sucesso');
      }
    });
  }
}
